import { CircularProgress, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

// Sized like the grid's own overlay (100% of the overlay area): DataGridPro v6 wraps overlays in a
// 0x0 sticky box, so an absolutely positioned one shrank to nothing. Stacked over the rows: the
// community grid (v5) puts its overlay before them, and the old rows drew over it at full strength.
const Veil = styled('div')({
    position: 'relative',
    zIndex: 4,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.72)',
});

// On a card: over the old rows the words ran into their text. A styled div, not a Box: Agent Metrics
// zeroes the padding of every .MuiBox-root inside it.
const Card = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
    padding: '16px 24px',
    backgroundColor: '#fff',
    borderRadius: '12px',
    boxShadow: '0 1px 4px rgba(16, 24, 40, 0.12)',
});

/**
 * A grid's LoadingOverlay slot with words: the grid's own small spinner over an empty table read as
 * "no data" (Ben, 2026-10-29). On a reload the old rows stay underneath, faded, so they never pass
 * for the new filters'. Use it through `gridLoadingSlots(label)`, once per page (module level), so
 * the slot keeps its identity between renders.
 */
export const GridLoadingOverlay = ({ label }) => (
    <Veil data-testid="grid-loading-overlay">
        <Card>
            <CircularProgress size={32} />
            <Typography sx={{ fontSize: 14, color: '#52514e' }}>{label}</Typography>
        </Card>
    </Veil>
);

export const gridLoadingSlots = (label) => ({
    LoadingOverlay: () => <GridLoadingOverlay label={label} />,
});
